import React from 'react';
import { Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { getControlTokens } from './controlTokens';

function ControlField({
  context = 'filterBar',
  width = 'auto',
  minWidth,
  maxWidth = '100%',
  align = 'center',
  children,
  sx,
}) {
  const theme = useTheme();
  const tokens = getControlTokens(theme, context);
  const resolvedWidth = typeof width === 'number' ? `${width}px` : width;
  const resolvedMinWidth = typeof minWidth === 'number' ? `${minWidth}px` : minWidth;
  const resolvedMaxWidth = typeof maxWidth === 'number' ? `${maxWidth}px` : maxWidth;

  return (
    <Box
      data-control-context={context}
      sx={{
        display: 'flex',
        alignItems: align,
        minHeight: tokens.height,
        width: resolvedWidth,
        minWidth: resolvedMinWidth,
        maxWidth: resolvedMaxWidth,
        flex: '0 0 auto',
        boxSizing: 'border-box',
        '& .MuiFormControl-root:not([data-control-inline-form="true"]), & .MuiAutocomplete-root': {
          width: '100%',
        },
        ...sx,
      }}
    >
      {children}
    </Box>
  );
}

export default ControlField;
